'use client'

import styles from './page.module.scss'
import { projects } from './data';
import Card from './card/Card';
import { useScroll } from 'framer-motion';
import { useEffect, useRef } from 'react';
import Lenis from '@studio-freight/lenis'


import React, {  useState } from 'react';

const CustomizePackage = () => {


    const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start start', 'end end']
  })

  useEffect( () => {
    const lenis = new Lenis()

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
  })


  const [dynamicTop, setDynamicTop] = useState('-165px'); // Default top margin
  const [buttonMarginBottom, setButtonMarginBottom] = useState('0px'); // Default button margin

  useEffect(() => {
    const updateLayout = () => {
      if (window.innerWidth < 768) {
        setDynamicTop('-95px'); // Adjust top margin for small screens
        setButtonMarginBottom('55px'); // Add margin below button on small screens
      } else {
        setDynamicTop('-115px'); // Default for larger screens
        setButtonMarginBottom('45px'); // Remove extra margin for larger screens
      }
    };

    updateLayout(); // Call on component mount
    window.addEventListener('resize', updateLayout); // Update on window resize

    return () => {
      window.removeEventListener('resize', updateLayout); // Cleanup on component unmount
    };
  }, []);

  const styles = {
    container: {
      fontFamily: 'Robots, sans-serif',
      position: 'relative',
      top: dynamicTop, // Use dynamic top margin
      margin: '0 auto',
      maxWidth: '1200px',
      padding: '40px 20px',
    },
    layout: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '20px',
      flexWrap: 'wrap',
    },
    imageSection: {
      flex: '1 1 30%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'auto', // Increased height for the circle
      width: 'auto', // Set the width equal to the height for a circular shape
      overflow: 'hidden', // Ensures the image stays inside the circle bounds
    },
    image: {
      width: '100%', // Make the image fill the container width
      height: '100%', // Make the image fill the container height
      borderRadius: '50%', // This makes the image circular
      objectFit: 'cover', // Ensure the image covers the entire area without distortion
    },
    servicesSection: {
      flex: '1 1 30%',
    },
    serviceItem: {
      border: '1px solid #e0e0e0',
      borderRadius: '12px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      marginBottom: '20px',
      background: '#ffffff',  /* Set background color to white */
      textAlign: 'center',
      transition: 'transform 0.3s ease',
    },
    serviceTitle: {
      fontSize: '1.4rem',
      color: '#000000',  /* Black text color */
      margin: '15px 0 10px',
    },
    serviceDescription: {
      fontSize: '1rem',
      color: '#000000',  /* Black text color */
      lineHeight: '1.5',
      margin: '0 0 10px',
    },
    callToAction: {
      textAlign: 'center',
      marginTop: '40px',
    },
    button: {
      backgroundColor: '#ff7f5f',
      color: '#fff',
      border: 'none',
      padding: '12px 30px',
      fontSize: '1rem',
      fontWeight: 'bold',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      marginBottom: buttonMarginBottom, // Dynamic margin for button
    },
    buttonHover: {
      backgroundColor: '#ff5635',
    },
  };
  

  return (
    <>
      <div className="bg-gray-100 ">
        <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
          <div className="mb-10 flex justify-center">
            <div className="text-center w-full lg:w-5/5">

              <h2 style={{
                fontSize: '1.4rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.6',
                marginBottom:'2px'
              }}  className="text-xl lg:text-2xl mb-2 font-semibold">


                Our customize package
              </h2>
              


              <main ref={container} className={styles.main}>
      {
        projects.map( (project, i) => {
          const targetScale = 1 - ( (projects.length - i) * 0.05);
          return <Card key={`p_${i}`} i={i} {...project} progress={scrollYProgress} range={[i * .25, 1]} targetScale={targetScale}/>
        })
      }
    </main>



            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default CustomizePackage;
